<template>
  <div class="page">
    <navigation adaption />
    <div class="content">
      <div class="top text-gray">
        <span class="back" @click="backHome">返回首页</span>
      </div>
      <div class="header corner shadow background-white">
        <div
          class="title text-dark"
          @click="buyAction"
          data-sensors-click
        >
          恭喜您获得提额特权，可再借<span class="text-red">{{ info.upLimit }}元</span> >
        </div>
        <div class="channel-count-down text-gray flex-row" v-if="countdownVisible">
          <div>距离免审通道关闭&nbsp;</div>
          <van-count-down
            :time="countDownSeconds"
            @finish="countDownFinished"
          />
        </div>
      </div>
      <div class="info corner shadow background-white">
        <div class="top-background text-yellow">
          <img src="./images/auth-guide-up/icon_auth_upGuide_info_top_bubble.png">
          <div class="title">免审提额 (元)</div>
          <div class="amount text-yellow">{{ formatAmount(info.upLimit) || 0 }}</div>
          <div class="tip">最终放款结果以资方审核为准，被拒2-7个工作日退款</div>
        </div>
        <img class="title-img" src="./images/auth-guide-up/img_auth_upGuide_info_title.png">
        <div class="amount-privilege">
          <div class="section-header text-dark flex-row">
            <div class="rect"></div><span class="text">提额权益</span>
          </div>
          <div class="items flex-row">
            <div class="item" v-for="item in info.financeBenefitList" :key="item.icon">
              <div class="bubble">{{ item.benefitDesc }}</div>
              <img :src="item.icon">
              <div class="name text-dark">{{ item.benefitName }}</div>
            </div>
          </div>
        </div>
        <div class="life-privilege">
          <div class="section-header text-dark flex-row">
            <div class="rect"></div><span class="text">生活权益</span>
          </div>
          <div class="items flex-row">
            <div class="item" v-for="(item, index) in info.lifeBenefitList" :key="index">
              <img :src="item.icon">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom background-white">
      <div class="buy-button" @click="buyAction" data-sensors-click>
        <span class="price text-white">「100%提额」售价 ¥{{info.discountPrice}}</span>
        <span class="origin text-white">原价 ¥{{info.price}}</span>
        <span class="ui-bubble" v-if="info.expireDate && (info.expireDate - new Date().getTime() >0)">
          <van-count-down
            :time="info.expireDate - new Date().getTime()"
            :format="dateFormat"
          />&nbsp;后涨价
        </span>
      </div>
      <div class="protocol">
        开通即同意<span @click="protocolAction">《会员用户协议》</span>
      </div>
    </div>
    <version-tips v-model="showVersionTips" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { WHPay } from '@/assets/buyVip'
import CountDownTool from '@/assets/CountDownTool.js'
import { hasNativeMethod } from '@/assets/jsBridge'
import { getKey, isAndroid, versionStringCompare } from '@/assets/utils'

export default {
  data () {
    return {
      info: {},
      countDownSeconds: 0,
      showVersionTips: false
    }
  },
  async created () {
    await this.getUpGuideInfo()
    this.$bus.$emit('ready')
    this.countDownSeconds = CountDownTool.setCountDownInfo(CountDownTool.Keys.upGuideCountDownTimeStamp, 15 * 60 * 1000)
  },
  computed: {
    countdownVisible () {
      return this.countDownSeconds > 0
    },
    dateFormat () {
      if (this.info.expireDate - new Date().getTime() > 86400000) {
        return 'DD天HH:mm:ss'
      } else if (this.info.expireDate - new Date().getTime() > 3600000) {
        return 'HH:mm:ss'
      } else {
        return 'mm:ss'
      }
    }
  },
  methods: {
    ...mapActions('authentication', ['upGuideInfo']),
    protocolAction () {
      this.$router.push('/protocol/vip-wh')
    },
    async getUpGuideInfo () {
      const response = await this.upGuideInfo()
      const { success, data } = response
      if (success) {
        this.info = data
      }
    },
    buyAction () {
      this.popVisible = false
      if (this.showVersionTipsDiff()) {
        this.showVersionTips = true
        return
      }
      WHPay(false, 'UPC_M', 'UP')
    },
    showVersionTipsDiff () {
      return isAndroid() &&
        hasNativeMethod('getUserInfo') &&
        getKey('appVersion') &&
        versionStringCompare('1.8.1.8', getKey('appVersion')) > 0
    },
    countDownFinished () {
      this.countDownSeconds = 0
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #F7F7f7;
  .content {
    padding: 0 30px 236px 30px;
  }
  .top {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding:30px 0;
    margin: 22px 0;
    .back {
      float: right;
      text-decoration: underline;
      text-align: right;
    }
  }
  .header {
    padding: 24px 30px 33px 30px;
    .title {
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 48px;
    }
    .channel-count-down {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 33px;
      align-items: center;
      .van-count-down {
        font-size: 24px;
        font-weight: 400;
        color: #FF4633;
        line-height: 33px;
      }
    }
  }
  .info {
    padding: 20px;
    text-align: center;
    margin-top: 20px;
    .top-background {
      background: url(./images/auth-guide-up/img_auth_upGuide_info_top_bg.png) no-repeat center center;
      background-size: 100%;
      height: 341px;
      text-align: center;
      img {
        width: 170px;
        height: 64px;
        margin-top: 39px;
        position: relative;
        left: 140px;
      }
      .title {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 40px;
      }
      .amount {
        font-size: 80px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        line-height: 97px;
        margin-top: -10px;
      }
      .tip {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #978982;
        line-height: 28px;
        margin-top: 24px;
      }
    }
    .title-img {
      width: 360px;
      height: 82px;
      margin-top: 25px;
    }
    .amount-privilege {
      .items {
        margin-top: 32px;
        justify-content: space-around;
        padding: 0 30px 0 0;
        .item{
          display: flex;
          flex-direction: column;
          align-items: center;
          .bubble {
            padding: 2px 10px;
            background: linear-gradient(90deg, #FFEB82 0%, #FFD450 100%);
            border-radius: 20px 20px 20px 0px;
            position: relative;
            top: 0;
            color: #7F3800;
            font-size: 20px;
            line-height: 28px;
            position: relative;
            left: 50px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
          img {
            width: 70px;
            height: 70px;
            margin-top: -13px;
          }
          .name {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 33px;
          }
        }
      }
    }
    .life-privilege {
      margin-top: 41px;
      .items {
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 20px;
        img {
          width: 320px;
          height: 101px;
        }
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.04);
    padding: 40px 40px 28px;
    text-align: center;
    .buy-button {
      height: 88px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 44px;
      align-items: center;
      padding: 0 40px;
      .price {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 88px;
      }
      .origin {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 88px;
        text-decoration: line-through;
        opacity: 0.6;
        margin-left: 15px;
      }
    }
    .protocol {
      margin-top: 25px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      span {
        color: #8EB2D8;
      }
    }
    .ui-bubble {
      background-color: #000;
      opacity: 0.8;
      border-radius: 20px 20px 20px 0px;
      color: #fff;
      font-size: 20px;
      padding: 4px 20px;
      position: absolute;
      left: 55%;
      top: 10px;
      display: flex;
      height: 44px;
      align-items: center;
      .van-count-down {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffd8bc;
        line-height: 33px;
      }
    }
  }
  .text-white {
    color: #ffffff;
  }
  .background-white {
    background: #ffffff;
  }
  .shadow {
    box-shadow: 0px 10px 20px 0px rgba(211,211,211,0.5);
  }
  .corner {
    border-radius: 20px;
  }
  .text-red {
    color: #FF4633;
  }
  .text-yellow {
    color: #FFDDB8;
  }
  .text-dark {
    color: #333333;
  }
  .text-gray {
    color: #666666
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  .rect {
    width: 6px;
    height: 30px;
    background: #DBBB9C;
  }
  .section-header {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 40px;
    text-align: left;
    align-items: center;
    .text {
      margin-left: 10px;
    }
  }
}
</style>